/**
 * LC Search Inline
 * Literary Sport-inspired inline expanding search
 */

class LcSearchInline extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.lc-search-inline__trigger');
    this.form = this.querySelector('.lc-search-inline__form');
    this.input = this.querySelector('.lc-search-inline__input');
    this.closeBtn = this.querySelector('.lc-search-inline__close');
    this.syncClosedWidth = this.syncClosedWidth.bind(this);
    this.bindEvents();
  }

  connectedCallback() {
    this.syncClosedWidth();
    window.addEventListener('resize', this.syncClosedWidth);

    if (document.fonts?.ready) {
      document.fonts.ready.then(this.syncClosedWidth);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.syncClosedWidth);
  }

  bindEvents() {
    // Open on trigger click
    this.trigger?.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    });

    // Close on close button click
    this.closeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.close();
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (this.isOpen() && !this.contains(e.target)) {
        this.close();
      }
    });

    // Prevent form submit if empty
    this.form?.addEventListener('submit', (e) => {
      const query = this.input?.value.trim();
      if (!query) {
        e.preventDefault();
        this.input?.focus();
      }
    });
  }

  isOpen() {
    return this.getAttribute('data-open') === 'true';
  }

  syncClosedWidth() {
    if (!this.trigger) return;

    const baseWidth = 68;
    const measuredWidth = Math.ceil(this.trigger.scrollWidth + 10);
    const closedWidth = Math.max(baseWidth, measuredWidth);
    this.style.setProperty('--lc-search-inline-closed-width', `${closedWidth}px`);
  }

  open() {
    this.setAttribute('data-open', 'true');
    this.trigger?.setAttribute('aria-expanded', 'true');
    setTimeout(() => {
      this.input?.focus();
    }, 50);
  }

  close() {
    this.setAttribute('data-open', 'false');
    this.trigger?.setAttribute('aria-expanded', 'false');
    if (this.input) {
      this.input.value = '';
    }
    this.trigger?.focus();
  }
}

// Register the custom element
if (!customElements.get('lc-search-inline')) {
  customElements.define('lc-search-inline', LcSearchInline);
}
